// src/services/empresaService.js
import { apiClient } from './api';

/**
 * Servicio para gestionar certificados de empresa.
 * Las empresas/organizaciones se gestionan desde UAU.
 */
export const empresaService = {
  /**
   * Obtener certificados de una empresa por RUT
   * @param {string} rutEmpresa - RUT de la empresa (sin DV, sin puntos)
   * @param {boolean} soloActivos - Filtrar solo certificados activos
   * @returns {Promise<Array>}
   */
  async getCertificados(rutEmpresa, soloActivos = true) {
    return apiClient.get(`/empresas/certificados/empresa/${rutEmpresa}?activos_only=${soloActivos}`);
  },

  /**
   * Cargar un nuevo certificado para una empresa
   * @param {FormData} formData - Datos del formulario con certificado y datos
   * @returns {Promise<Object>}
   */
  async cargarCertificado(formData) {
    return apiClient.uploadFile('/empresas/certificados', formData);
  },

  /**
   * Eliminar un certificado
   * @param {number} certificadoId - ID del certificado a eliminar
   * @returns {Promise<Object>}
   */
  async eliminarCertificado(certificadoId) {
    return apiClient.delete(`/empresas/certificados/${certificadoId}`);
  },

  /**
   * Obtener configuración SII portal de una empresa (rut_rep_legal, sin clave)
   * @param {string} rutEmpresa
   * @returns {Promise<Object>} - { rut_empresa, rut_rep_legal, configurada }
   */
  async getConfigSii(rutEmpresa) {
    return apiClient.get(`/empresas/config-sii/${rutEmpresa}`);
  },

  /**
   * Crear o actualizar configuración SII portal de una empresa
   * @param {Object} data - { rut_empresa, rut_rep_legal, clave_sii }
   * @returns {Promise<Object>}
   */
  async upsertConfigSii(data) {
    return apiClient.post('/empresas/config-sii', data);
  },

  async getJobsSii(rutEmpresa) {
    return apiClient.get(`/empresas/config-sii/${rutEmpresa}/jobs`);
  },

  async ejecutarDescargaSii(rutEmpresa) {
    return apiClient.post(`/empresas/config-sii/${rutEmpresa}/ejecutar`);
  },

  async getConfigTributaria(rutEmpresa) {
    return apiClient.get(`/empresas/config-tributaria/${rutEmpresa}`);
  },

  async upsertConfigTributaria(rutEmpresa, data) {
    return apiClient.put(`/empresas/config-tributaria/${rutEmpresa}`, data);
  },
};
